import { useState,useEffect } from "react";
import { ReactSession } from "react-client-session";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

import FourCss from '../404/four04.module.css';
import SpaceError from '../../resources/images/error-page.gif';
import Loading from "../common/Loading";
import SyncLoader from "react-spinners/SyncLoader";


const Validator = () => {
    const navigate = useNavigate();
    const {token} = useParams();
    
    const [ paraToken,setParaToken ] = useState('');
    const [ loading,setLoading ] = useState(true);
    const [ msg,setMsg ] = useState('');
    const [ slowLoad,setSlowLoad ] = useState(false);

    const isError = msg === "Error! Unauthorized Token" || msg === "Error! Some Error Occured";

    useEffect(() => {
      const slowLoadTimer = setTimeout(() => setSlowLoad(true), 7000);
      return () => clearTimeout(slowLoadTimer);
    }, []);

    useEffect(() => {
      if(token)
      {
        setParaToken(token);
      }
      else
      {
        navigate('/error');
      }
    }, []);

    useEffect(() => {
        const pageToNav = ReactSession.get("lastNavigate") ?? "";
        setLoading(true);
        if(paraToken !== '')
        {
            const endPoint = process.env.REACT_APP_AUTH_EP;
            let rqUrl = `${endPoint}auth/authorize`;
            
            axios({
                // Endpoint to get NFTs
                url: rqUrl,
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${paraToken}`,
                    "ngrok-skip-browser-warning": "69420"
                }
            })
            // Handle the response from backend here
            .then((res) => {
                setLoading(false);
                //console.log(res.data);
                if(res.data.success === true)
                {
                    setMsg('Please Wait');
                    // header set : res.data.result.access_token
                    ReactSession.set("xTkn", res.data.result.access_token);
                    // navigate('/overview')

                    setTimeout(() => {
                        if(res.data.result.is_new_user === true)
                            navigate('/select-plan')
                        else if(pageToNav === "pricing") {
                            ReactSession.set("lastNavigate", "");
                            navigate('/pricing')
                        }
                        else if(pageToNav === "onboard") {
                            ReactSession.set("lastNavigate", "");
                            navigate('/select-plan')
                        }
                        else
                            navigate('/overview');
                    }, 600);
                }
                else
                {
                    setMsg('Error! Unauthorized Token');
                    //remove Token
                }
            })
            // Catch errors if any
            .catch((err) => {
                console.warn(err);
                setMsg('Some Error Occured!');
                setLoading(false);
            });
        }
    }, [paraToken])
    
    
    return ( 
        <div className={FourCss.main_container}>
            
            {loading && 
                <div style={{ width: '100vw', height: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <SyncLoader color='#f4f4f4'/>
                </div>
            }
            <div className="container-lg">
                {(msg === "Please Wait") && <div className="text-center pt-5">
                    <SyncLoader color="#f4f4f4" size={20} />
                </div>}
                {(msg === "Error! Some Error Occured") && <div className="text-center pt-5">
                    <img src={SpaceError} alt="Not Found" className="img-fluid mx-auto" />
                </div>}
                <div className="text-center">
                    <h1 className={FourCss.text}>{(msg !== "Please Wait") && msg}</h1>
                    {slowLoad && !isError && <p className={FourCss.text} style={{ fontSize: '1rem' }}>Taking too long to load?</p>}
                    {(slowLoad || isError) && <a href="https://shyft.to/" className={FourCss.btn_solid_grad}>Homepage</a>}
                </div>
            </div>
        </div>
     );
}
 
export default Validator;